export const OPPORTUNITY_PREFIX_SIZE = 5;
export const HIGH_CONFIDENCE_MIN = 0.66;
export const MEDIUM_CONFIDENCE_MIN = 0.33;
export const PULSE_OPPORTUNITIES_VIEW_EVENT_TYPE = 'widget_view';
export const PULSE_OPPORTUNITIES_ENTITY_NAME = 'pulse_opportunities';
